<template>
  <div class="main-image">
    <div class="main-pic">
      <img
        :src="'/static/pictures/mock/main-image-static.jpg'"
        alt=""
        class="img-store"
      />
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.main-image {
  position: relative;
}

.main-pic {
  padding-bottom: 20px;
}

.img-store {
  width: 100%;
}
</style>